import React from "react";
import PoliciesReportCard from "../../components/policiesReportCard";
import { IMAGE_BASE_URL } from "../../data/baseURL";
import { useScrollTop } from "../../hook/useScrollTop";
// import Diversity from "../../sections/diversity";
// import GenderPay from "../../sections/gender-pay";
// import Methodology from "../../sections/methodology";
import { AboutDataContext } from "./about";

const DiversityAndInclusion = () => {
  const { about_report } = React.useContext(AboutDataContext);
  useScrollTop();

  return (
    <section className="ms-35 me-35 mt-7 pb-7">
      {about_report?.map((data, index) => (
        <div key={index} className={`${index > 0 ? "pt-7" : ""}`}>
          <h1 className="pb-5">
            <img
              src={`${IMAGE_BASE_URL}/${data?.image}`}
              height={45}
              width={50}
              alt=""
            />{" "}
            <span className="fs-38 lh-40 gilroy-bold text-capitalize">
              {data?.title}
            </span>
          </h1>
          {data?.presentation_report?.map((data, index) => (
            <PoliciesReportCard
              key={index}
              data={data}
              index={index}
              downloadURL="presentation-slight-download"
            />
          ))}
        </div>
      ))}
      {/* <Diversity />
      <GenderPay />
      <Methodology /> */}
    </section>
  );
};

export default DiversityAndInclusion;
